import { z } from 'zod';
/** `venue_profile.key`: one venue only (working assumption 3). */
export const VENUE_KEYS = ['WANDERERS'];
export const VenueKeySchema = z.enum(VENUE_KEYS);
/** `venue_profile.socialLinks[].platform`. */
export const SOCIAL_PLATFORMS = ['FACEBOOK', 'X', 'INSTAGRAM', 'YOUTUBE', 'TIKTOK'];
export const SocialPlatformSchema = z.enum(SOCIAL_PLATFORMS);
/** `cms_pages.key`. */
export const CMS_PAGE_KEYS = ['TERMS', 'PRIVACY'];
export const CmsPageKeySchema = z.enum(CMS_PAGE_KEYS);
//# sourceMappingURL=venue.js.map